export default __webpack_public_path__ + "static/media/edit_outline_blue.2dae4b54.svg";